import React, { useState } from "react";
import "./Form.css";
import Popup from "./popup";
import { availableServices } from "./data";
import { loadOpinions, submitOpinion } from "../api";

const Form = ({ commentsRef }) => {
  const [name, setName] = useState(""); // State for the name input
  const [services, setServices] = useState([]); // State for the selected services
  const [comment, setComment] = useState(""); // State for the comment input
  const [errors, setErrors] = useState({}); // State for form validation errors
  const [isCommentsPopupOpen, setIsCommentsPopupOpen] = useState(false); // State for the popup visibility

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    try {
      await submitOpinion(name, services, comment); // Submit the opinion

      // Reset form fields
      setName("");
      setServices([]);
      setComment("");
      setIsCommentsPopupOpen(false);
      await loadOpinions(); // Reload opinions
      if (commentsRef.current) {
        commentsRef.current.scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const { errors } = error.response.data;
        const formattedErrors = {};
        errors.forEach((err) => {
          formattedErrors[err.param] = err.msg;
        });
        setErrors(formattedErrors); // Set validation errors
      }
    }
  };

  return (
    <>
      <div className="btn-form">
        <button
          className="btn-c"
          type="button"
          onClick={() => setIsCommentsPopupOpen(true)}
        >
          <img
            className="final-pictures"
            src="opinion.png"
            alt="Button to leave a comment"
          />
        </button>
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://wa.me/523310684078?text=Hola!%20Me%20interesa%20informaci%C3%B3n"
        >
          <img
            className="final-pictures"
            src="agenda cita.png"
            alt="WhatsApp"
          />
        </a>
      </div>
      <div className="form-container">
        <Popup
          isOpen={isCommentsPopupOpen}
          onClose={() => setIsCommentsPopupOpen(false)}
        >
          <form onSubmit={handleSubmit}>
            <div className="comment-form">
              <div className="name-txt-contnainer">
              <h3 className="popup-name-h">Nombre</h3>
              </div>
              <div className="name-form">
                <input
                  className="input-name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.error === "Please enter a valid name." && (
                  <p className="error-message">{errors.name}</p>
                )}
              </div>

              <div className="services-form">
                <p className="serv-form">Servicios contratados</p>
                <div className="services-boxes">
                  {availableServices.map((service) => (
                    <label key={service} className="checkbox-label">
                      <input
                        className="box-option"
                        type="checkbox"
                        value={service}
                        checked={services.includes(service)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setServices([...services, service]);
                          } else {
                            setServices(services.filter((s) => s !== service));
                          }
                        }}
                      />
                      <span className="checkbox-text">{service}</span>
                    </label>
                  ))}
                </div>
                {errors.services && (
                  <p className="error-message">{errors.services}</p>
                )}
              </div>

              <div className="commenttxt-form">
                <h3 className="tell-opinion">Cuentanos tu opinión</h3>
                <textarea
                  className="textarea"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
                {errors.comment && (
                  <p className="error-message">{errors.comment}</p>
                )}
                <div
                  className="g-recaptcha"
                  data-sitekey="6LeVXckqAAAAAITWio63KvMPp_WY-JtiXJdLNNct"
                ></div>
                <button className="submit-btn" type="submit">
                  Enviar
                </button>
              </div>
            </div>
          </form>
        </Popup>
      </div>
    </>
  );
};

export default Form;
